/** @type {import('./$types').PageLoad} */
export async function load() {
	return { step: 1 };
}
